
export function getQueryString(url: string):any {
    const [path, queryString] = url.split("?");
    
    if (!queryString) {
    return{path,queryObject:{}}

    }
    
    const queryObject: { [key: string]: string } = {};
    queryString.split("&").forEach(param => {
        const [key, value] = param.split("=");
        if (key) {
            queryObject[decodeURIComponent(key)] = value ? decodeURIComponent(value) : '';
        }
    });
    return{path,queryObject}
}